'use client';

import Image from 'next/image'
import LocalizedClientLink from "@modules/common/components/localized-client-link"
import CarouselSection from '@modules/common/components/carousel-section'
import { HOMEPAGE_CATEGORIES } from '@constants/homepage'
import type { CategoryCard } from '@constants/homepage'

export default function Categories() {
  return (
    <CarouselSection
      title="Categories"
      sectionId="categories"
      items={HOMEPAGE_CATEGORIES}
      ariaLabel="Categories"
      scrollAmount={280}
      gap="gap-6"
      padding="xs"
      keyExtractor={(item: CategoryCard) => item.id}
      renderItem={(item: CategoryCard) => (
        <LocalizedClientLink
          href={item.href}
          className="group block relative flex-shrink-0 w-[220px] rounded-2xl overflow-hidden outline-none focus-visible:ring-2 focus-visible:ring-brand-navy focus-visible:ring-offset-2"
        >
          <div className="relative aspect-[3/4]">
            <Image
              src={item.image}
              alt={item.name}
              fill
              className="object-cover group-hover:scale-105 transition-transform duration-300"
              sizes="220px"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />
          </div>

          <div className="absolute bottom-0 left-0 right-0 p-5">
            <h3 className="text-lg font-bold text-white mb-2">
              {item.name}
            </h3>
            <span className="px-5 py-2 bg-white text-brand-navy text-sm font-semibold rounded-full inline-block">
              Shop now
            </span>
          </div>
        </LocalizedClientLink>
      )}
    />
  )
}
